import React, { useEffect } from 'react';
import { StickyHeader } from './components/StickyHeader';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { PainSection } from './components/PainSection';
import { ProductIntro } from './components/ProductIntro';
import { WorkbooksSection } from './components/WorkbooksSection';
import { BonusesSection } from './components/BonusesSection';
import { ValueStack } from './components/ValueStack';
import { AudienceSection } from './components/AudienceSection';
import { Testimonials } from './components/Testimonials';
import { HowItWorks } from './components/HowItWorks';
import { Guarantee } from './components/Guarantee';
import { ClosingBlock } from './components/ClosingBlock';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { FloatingCTA } from './components/FloatingCTA';
export function App() {
  useEffect(() => {
    document.title = 'CHIMICA VISIVA™ | Risorse digitali pronte all’uso per insegnare chimica';
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'CHIMICA VISIVA™ è il sistema didattico digitale completo per insegnare chimica: schede teoriche visuali, attività, laboratori, verifiche A/B, soluzioni per il docente, giochi e progetti scientifici. 504 pagine pronte da stampare, pagamento unico e accesso immediato.');
  }, []);
  return <div className="w-full bg-paper text-ink" data-id="element-0" data-mp="3dm5y7yvyoigr">
      <StickyHeader data-id="element-1" data-mp="nw2a60hx7gog" />
      <main data-id="element-2" data-mp="nuhhyhj2w9tr">
        <span id="hero-sentinel" aria-hidden="true" data-id="element-3" data-mp="nv0z3w0wmu6q" />
        <Hero data-id="element-4" data-mp="sudmqizlo5ad" />
        <SocialProofBar data-id="element-5" data-mp="stuexv3nyxa2" />
        <PainSection data-id="element-6" data-mp="stccggqermtp" />
        <ProductIntro data-id="element-7" data-mp="swqcvjfihlyi" />
        <WorkbooksSection data-id="element-8" data-mp="36hzxgtw5a5z" />
        <BonusesSection data-id="element-9" data-mp="35oy8u9shaup" />
        <ValueStack data-id="element-10" data-mp="34x3flo0nh5h" />
        <AudienceSection data-id="element-11" data-mp="38kvshhq5xim" />
        <Testimonials data-id="element-12" data-mp="3ud1ff9ao9oam" />
        <HowItWorks data-id="element-13" data-mp="3ubrfeek9e61c" />
        <Guarantee data-id="element-14" data-mp="3uc9k7zkzlskv" />
        <ClosingBlock data-id="element-15" data-mp="3uevq7us8c00z" />
        <FAQ data-id="element-16" data-mp="d4e5zu7z1ex8" />
        <Footer data-id="element-17" data-mp="d57fv4288kjl" />
        <div className="h-[54px] md:hidden" aria-hidden="true" data-id="element-18" data-mp="d3mmvivk99nu" />
        <SocialProofPopup data-id="element-19" data-mp="85ui3o9tht28" />
        <FloatingCTA data-id="element-20" data-mp="86mf93j2byum" />
      </main>
    </div>;
}